import {
  Box,
  IconButton,
  Tab,
  Tabs,
  ThemeProvider,
  Tooltip,
  Typography,
} from "@mui/material";
import { useState } from "react";
import { FiPlus } from "react-icons/fi";
import { IoMdSearch } from "react-icons/io";
import { theme } from "../../Common/SetupProfile/constant";
import { BrandList } from "./Tabs/BrandList";
import BrandAddModal from "./BrandAddModal";

export const BrandApproval = () => {
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [selectedTab, setSelectedTab] = useState("pending");
  const [currentPage, setCurrenPage] = useState(1);
  const [influencers, setInfluencers] = useState([
    {
      id: 1,
      name: "John Morgan",
      username: "@john_Morgan",
      avatar: "https://example.com/avatar1.jpg",
      affiliated: true,
      email: "abc@gmai.com",
      phone: "123456789",
      registeredDate: "28/04/2025",
      status: "active",
    },
    {
      id: 2,
      name: "John Morgan",
      username: "@john_Morgan",
      avatar: "https://example.com/avatar1.jpg",
      affiliated: true,
      email: "abc@gmai.com",
      phone: "123456789",
      registeredDate: "28/04/2025",
      status: "inactive",
    },
    {
      id: 3,
      name: "John Morgan",
      username: "@john_Morgan",
      avatar: "https://example.com/avatar1.jpg",
      affiliated: true,
      email: "abc@gmai.com",
      phone: "1234567890",
      registeredDate: "28/04/2025",
      status: "active",
    },
    {
      id: 4,
      name: "John Morgan",
      username: "@john_Morgan",
      avatar: "https://example.com/avatar1.jpg",
      affiliated: false,
      email: "abc@gmai.com",
      phone: "1234567890",
      registeredDate: "28/04/2025",
      status: "active",
    },
  ]);

  const handleChange = (_, newValue) => {
    setSelectedTab(newValue);
  };

  return (
    <>
      <ThemeProvider theme={theme}>
        <Box
          sx={{
            height: "calc(100vh - 126px)",
            overflow: "hidden",
          }}
        >
          <Box display={"flex"} justifyContent={"space-between"}>
            <Typography
              sx={{
                fontWeight: 600,
                fontSize: "20px",
                "& span": {
                  fontWeight: 400,
                  fontSize: "12px",
                },
              }}
            >
              Brands <span>(100)</span>
            </Typography>
            <Box display={"flex"} gap={2}>
              <Tooltip title="Search">
                <IconButton
                  sx={{
                    border: "1px solid #DDDDDD",
                  }}
                >
                  <IoMdSearch />
                </IconButton>
              </Tooltip>
              <Tooltip title="Add Influencer">
                <IconButton
                  onClick={handleOpen}
                  sx={{
                    border: "none",
                    background: "#6B8E76",
                    "&:hover": {
                      background: "#6B8E76",
                    },
                  }}
                >
                  <FiPlus color="#fff" />
                </IconButton>
              </Tooltip>
            </Box>
          </Box>
          <Box>
            <Tabs value={selectedTab} onChange={handleChange}>
              <Tab label={"Pending"} value={"pending"} />
              <Tab label={"Approved"} value={"approved"} />
              <Tab label={"Declined"} value={"declined"} />
            </Tabs>
          </Box>
          <Box>
            <BrandList
              state={selectedTab}
              data={[...influencers, ...influencers, ...influencers]}
              containerSx={{
                maxHeight: "calc(100vh - 226px)",
              }}
              total={Math.ceil(50 / 20)}
              currentPage={currentPage}
              onPageChange={(nextPage) => setCurrenPage(nextPage)}
            />
          </Box>
        </Box>
      </ThemeProvider>
      <BrandAddModal open={open} handleClose={handleClose} />
    </>
  );
};
